// extracted by css-extract-rspack-plugin
export default {"cls1":"PullToRefresh-cls1_Y0U","cls2":"PullToRefresh-cls2_l-P PullToRefresh-cls1_Y0U"};